import React from 'react';
import './index.css';
import SiderMenu from '@pages/Assembly/siderMenu';
import { Flex } from '@components';
import { Button, Table, Icon, InputNumber, Input, Modal, message } from 'antd';
import { mkbz } from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import { createUuid, getLoginUser } from '@utils/NHCore';
import NHFetch from "../../../../utils/NHFetch";
import CommonTip from "../common";
import NextButton from '@pages/SelfHelp/common/nextIndex'

const {confirm} = Modal;

export default class customizeExamination extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hjmc: '',
            operable: true,//是否显示环节
            isAllPay: true,
            xsssruYwxx: [],
            jgfs:'',
            taskid:'',
            mkbz:'',
            menuList:[],
            nextUrl:'',//左侧菜单加载完后传进来
            search:'',
        };
    }

    componentDidMount() {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        let mkbz = this.getQueryString('mkbz');
        this.setState({
            mkbz:mkbz,
        });
        this.getTaskidAndJgfs();
        this.queryQztjAndYlhj();
    }

    //查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            this.setState({
                nonOperationalData: { nologin: true },
                operable: false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    this.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        this.setState({ operable: false });
                    }
                }
            });
    }

    getTaskidAndJgfs =()=>{
        const zzbdhjid = this.getUrlParams("pkid");
        let params = {zzbdhjid: zzbdhjid};
        NHFetch('/questionnaire/getTaskidAndJgfs', 'GET', params)
            .then(res => {
                if (res && res.data) {
                    console.info(res.data);
                    this.setState({
                        taskid: res.data.TASKID,
                        jgfs: res.data.JGFS,
                    })
                    this.getUserCjById();
                } else {
                    message.error('未获取问卷，请联系管理员！');
                }
            });
    }

    //查询学生入学教育考试成绩
    getUserCjById = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        const zzbdhjid = this.getUrlParams("pkid");
        const taskid = this.state.taskid;
        const jgfs = this.state.jgfs;
        NHFetch('/questionnaire/getUserCjById', 'GET', {
            zzbdhjid:zzbdhjid,
            jgfs: jgfs,
            xsid: xsid,
            taskid: taskid
        })
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        xsssruYwxx: res.data
                    });
                    this.refs.siderMenu.reloadMenuList()
                }
            });
    };


    //环节pkid
    getQueryString = (name) => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    //获取url中传递的参数
    getUrlParams = (param) => {
        return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    };

    setMenuList=(menuList)=>{
        this.setState({menuList:menuList});
        this.setNext(menuList);
    }

    setNext = (menuList) => {
        if(!menuList || menuList.length==0){
            return;
        }
        let nextCount = 0;
        let bz = this.getQueryString("mkbz");
        menuList.map((elem,index)=>{
            if(elem.HJDM==bz){
                nextCount = index+1;
                return;
            }
        });
        let menu = menuList[nextCount];
        if (menu) {
            let hjdm = menu.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            }else if(hjdm.indexOf('DCWJ')==0 ){
                let wjUrl = "/customizeExamination";
                this.setState({
                    nextUrl: wjUrl,
                    search: 'pkid=' + menu.PKID+'&mkbz='+hjdm,
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }

    startStudy =()=>{
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        const taskid = this.state.taskid;
        const ksrkcsbz = "YXXT_KSRK_HBDX";
        let params = {ksrkcsbz: ksrkcsbz,taskid: taskid,xsid: xsid};
        NHFetch('/questionnaire/getKsrk', 'GET', params)
            .then(res => {
                if (res && res.data) {
                    if(res.data != "-1"){
                        window.open(res.data);
                        const getUserCjById = this.getUserCjById;

                        confirm({
                            title: '是否完成入学教育考试?',
                            okText: '已完成',
                            okType: 'success',
                            cancelText: '未完成',
                            onOk() {
                                getUserCjById(true);
                            },
                            onCancel() {
                                getUserCjById(true);
                            },
                        });
                    }else{
                        message.error('你没有参与考试资格，请联系管理员！');
                    }
                } else {
                    message.error('未获取考试入口，请联系管理员！');
                }
            });


    }

    //重新加载菜单
    reloadMenu=()=>{
        this.refs.siderMenu.reloadMenuList()
    }

    reload=()=>{
        let mkbz = this.getQueryString('mkbz');
        if(this.state.mkbz != mkbz){
            this.setState({
                mkbz:mkbz,
            },()=>{
                let mkbz = this.getQueryString('mkbz');
                this.setState({
                    mkbz:mkbz,
                 });
                 this.getTaskidAndJgfs();
                 this.queryQztjAndYlhj();
            });
        }
    }

    render() {
        this.reload();
        const { xsssruYwxx,jgfs } = this.state;

        const columns = [
            {
                title: '考试时间',
                dataIndex: 'START_TIME',
            },
            {
                title: '考试成绩',
                dataIndex: 'RESULT_SCORE',
            }
        ];

        return (
            <div styleName="page_buy">
                {this.state.operable ?
                    <Flex className="w1180 mt-20" align="start">
                        <SiderMenu
                            ref={"siderMenu"}
                            setMenuList={this.setMenuList}
                            title="自助报到"
                            mkbz={this.state.mkbz}
                            menuType="自助报到"
                        />
                        <Flex.Item className="page_con_r">
                            <Breadcrumb
                                noLine
                                list={[
                                    { name: '首页', url: '/index' },
                                    { name: '自助报到', url: '/register' },
                                    { name: this.state.hjmc }
                                ]}
                            />
                            <div className="box">
                                <Hint />
                                {this.state.jgfs ?
                                <TitleTop title={this.state.hjmc+` （及格分数： `+this.state.jgfs+` 分及以上）`} extra={false} />
                                :<TitleTop title={this.state.hjmc+` （未设置及格标准）`} extra={false} />}
                                <div className="p-sw">
                                    <Table
                                        bordered
                                        size="middle"
                                        pagination={false}
                                        columns={columns}
                                        dataSource={xsssruYwxx}
                                    />
                                    <div className="text-center mt-50">
                                        <Button onClick={this.startStudy}
                                                type="primary"
                                                className={"ml-20"}
                                                htmlType="submit">考试入口</Button>
                                        <NextButton nextUrl={this.state.nextUrl} before={this.checkNext}
                                                    search={this.state.search}/>
                                    </div>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex> : <CommonTip hjmc={this.state.hjData['HJMC']} key={"DCWJ"} mkbz={this.state.mkbz} nonOperationalData={this.state.nonOperationalData} />}
            </div>
        );
    }
}
